// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__wnqlJ","SpinnerAnimation":"Spinner_SpinnerAnimation__18tpk"};